export default "__VITE_ASSET__CbXUA_Bb__"